import {
    // FILE_UPLOAD,
    CREATE_BUSINESSDEVELOPMENT,
    RETRIEVE_BUSINESSDEVELOPMENT,
    RETRIEVESINGLE_BUSINESSDEVELOPMENT,
    UPDATE_BUSINESSDEVELOPMENT,
    DELETE_BUSINESSDEVELOPMENT,
} from "./type";
import BusinessDevelopment from "../service/BusinessDevelopment";
export const create = (data) => async (dispatch) => {
    try {
        const res = await BusinessDevelopment.create(data);
        dispatch({
            type: CREATE_BUSINESSDEVELOPMENT,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await BusinessDevelopment.fetchList(data);
        dispatch({
            type: RETRIEVE_BUSINESSDEVELOPMENT,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};


export const retrieveEmployeeStartersLeavers = (data) => async (dispatch) => {
    try {
        const res = await BusinessDevelopment.fetchEmployeeStartersLeaversList(data);
        // dispatch({
        //     type: RETRIEVE_BUSINESSDEVELOPMENT,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};


export const retrieveServiceUserSummary = (data) => async (dispatch) => {
    try {
        const res = await BusinessDevelopment.fetchServiceUserSummaryList(data);
        // dispatch({
        //     type: RETRIEVE_BUSINESSDEVELOPMENT,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};


export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await BusinessDevelopment.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_BUSINESSDEVELOPMENT,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await BusinessDevelopment.update(data);
        dispatch({
            type: UPDATE_BUSINESSDEVELOPMENT,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await BusinessDevelopment.changeStatus(data);
//         dispatch({
//             type: UPDATE_BUSINESSDEVELOPMENT,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await BusinessDevelopment.trash(data);
        dispatch({
            type: DELETE_BUSINESSDEVELOPMENT,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};